export default __webpack_public_path__ + "eb088f299ed704898b1baca79d933a75.woff2";